import React, { useEffect } from 'react';
import { Pagination as RDCPagination } from '@uncinc/uncinc-react-kitchen-sink';
import { usePagination } from 'react-instantsearch-core';
import './style.scss';
const SearchPagination = props => {
  const {
    previousLabel,
    nextLabel,
    disableScrollTo = false,
    scrollToPositionTop = 0
  } = props;
  const pagination = usePagination();

  // Ensure we scroll to top when the page changes.
  useEffect(() => {
    if (!disableScrollTo) {
      window.scrollTo({
        top: scrollToPositionTop,
        behavior: 'smooth'
      });
    }
  }, [disableScrollTo, scrollToPositionTop, pagination.currentRefinement]);
  return /*#__PURE__*/React.createElement(RDCPagination, {
    currentPage: pagination.currentRefinement + 1,
    totalPages: pagination.nbPages,
    setCurrentPage: page => pagination.refine(page - 1),
    previousLabel: previousLabel,
    nextLabel: nextLabel,
    controlled: true
  });
};
export default SearchPagination;